import React, {useContext} from 'react';

/**
 * The expectation is a RouteComponent might be next/link or react-router-dom/link
 */
export interface RouteComponentProps extends JSX.Element {
    href?: string;
    to?: string;
}

interface ImageHeroContextProps {
    spacing: 'default' | 'thin';
}

interface OutlinedCardContextProps {
    arrows: boolean | 'arrow-right-alt';
    noBorder: boolean;
}

interface QuoteIconContextProps {
    icon: 'default' | 'rounded';
}
interface CarouselContextProps {
    icon: 'default' | 'alt';
}

interface Pushable {
    push: (arg0: string | any) => void;
}

export interface UnrealUIContextProps {
    RouteComponent: React.ElementType<any>;
    router: Pushable;
    imageHero?: ImageHeroContextProps;
    outlinedCard?: OutlinedCardContextProps;
    quoteIcon?: QuoteIconContextProps;
    carousel?: CarouselContextProps;
    staticIndustry?: string;
}

/**
 * Used as an app wide configuration for epic-ue-ui components
 */
export const UnrealUIContext = React.createContext<UnrealUIContextProps>({
    RouteComponent: 'a',
    router: {
        push: () => {
            console.log(
                'UnrealUIContext.router() default push handler. Override this with the UnrealUIContext'
            );
        }
    },
    imageHero: {
        spacing: 'default'
    },
    outlinedCard: {
        arrows: false,
        noBorder: false
    },
    quoteIcon: {
        icon: 'default'
    },
    carousel: {
        icon: 'default'
    },
    staticIndustry: ''
});

export const useUnrealUIContext = (): UnrealUIContextProps => {
    return useContext<UnrealUIContextProps>(UnrealUIContext);
};
